
export const webBoard = {
  maxRecordLength : 100
}

export const puzzle = {
  stringLength: {
    title: 30,
    comment: 50,
    tag: 10,
  },
  arrayLength: {
    tags: 5,
  }
}

export const signUp = {
  stringLength: {
    userName: 16
  },
  format: {
    userName: /[^0-9a-zA-Z]+/
  }
}

export const accountSettings = {
  stringLength: {
    userName: 16,
    displayName: 20,
    city: 10,
    profileHTML: 2000,
  },
  format: {
    userName: /[^0-9a-zA-Z]+/
  }
}

export const event = {
  stringLength: {
    name: 50,
    place: 50,
    detail: 5000,
  }
}


// WEBPACK FOOTER //
// ./src/constants/Limit.js